<template>
<div>
  <div class="box">
   <img border="0" src="@/assets/images/hunzhiCode.jpeg" style="width:50%; height:50%"/>
   <span style="color:#FFFFFF;">长按识别，关注公众号~</span>
  </div>
<div class="box1" >
   <img border="0" src="@/assets/images/hunzhiCode2.jpeg" style="width:72%; height:50%"/>
  </div>
</div>
</template>


<script>
import axios from 'axios'
export default {
 name: 'Channel',
    mounted() {this.visitLog(this.$route.query.channelId)},
    methods: {
         async visitLog(id) {
            axios.defaults.headers.post['Content-Type']='application/json';
            await axios.post('/app/api/cms/channel',{"channelId":id})
        .catch(function (error) {
            console.log(error);
        })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../assets/font/font.css";
.box{
 position: relative;
 padding-top: 100%;
 overflow: hidden;
 width: 100%;
 float: left;
 background-color: #dc462d; 
 font-size:0;
 }
  .box span {
        position: relative;
        display: inline-block;
        font-size:x-large;
        margin-top:-50px;
        font-family: SourceHanSansCN-Normal;
        transform: translate(25%, -30%);
        
    }
 .box img{
 position: absolute;
	top: 50%;
	transform: translate(50%, -50%);
   margin-bottom:-50px
 }
 .box1{
 position: relative;
 padding-top: 100%;
 overflow: hidden;
 width: 100%;
 float: left;
 background-color: #FFFFFF; 
 font-size:0;
 }
 .box1 img{
 position: absolute;
	top: 50%;
	transform: translate(20%, -50%);
   margin-bottom:-50px
 }
 </style>